package com.dotdrives.web.pages.drives

import com.dotdrives.design.DotButtonVariant
import com.dotdrives.web.ui.DotButton
import react.FC
import react.Props
import react.dom.aria.AriaRole
import react.dom.html.ReactHTML.b
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.span
import react.useState
import web.cssom.ClassName
import web.html.ButtonType
import web.html.button as buttonType

external interface MoveConfirmDialogProps : Props {
    var driveTitle: String
    var targetPhaseName: String
    var askAmount: Double?
    var onCancel: () -> Unit
    var onConfirm: (outcome: String?) -> Unit
}

private data class MoveOption(val outcome: String?, val icon: String, val title: String, val subtitle: String?)

val MoveConfirmDialog = FC<MoveConfirmDialogProps> { props ->
    val options = listOf(
        MoveOption(
            "pledged",
            "🤝",
            "They pledged",
            props.askAmount?.let { "Record a ${formatMoneyFull(it)} pledge" } ?: "Set a positive ask amount before recording a pledge",
        ),
        MoveOption("received", "💚", "Gift received", "Enter the actual gift details before saving"),
        MoveOption(null, "↩", "Not yet — just moving it", null),
    )
    val (selected, setSelected) = useState(options.first())

    div {
        className = ClassName("drives-dialog-backdrop")
        role = "presentation".unsafeCast<AriaRole>()
        onClick = { props.onCancel() }

        div {
            className = ClassName("drives-dialog drives-move-dialog")
            role = "dialog".unsafeCast<AriaRole>()
            ariaModal = true
            ariaLabel = "Move drive"
            onClick = { it.stopPropagation() }

            div { className = ClassName("drives-move-title"); +"Move to ${props.targetPhaseName}? 🎉" }
            div {
                className = ClassName("drives-move-copy")
                +"Nice — "
                b { +props.driveTitle }
                +" is heading to ${props.targetPhaseName}. Log what happened:"
            }
            div {
                className = ClassName("drives-move-options")
                options.forEach { option ->
                    button {
                        type = ButtonType.buttonType
                        className = ClassName(
                            "drives-move-option" +
                                if (option == selected) " drives-move-option-selected" else "",
                        )
                        onClick = { setSelected(option) }
                        span { +option.icon }
                        div {
                            className = ClassName("drives-move-option-copy")
                            div { className = ClassName("drives-move-option-title"); +option.title }
                            option.subtitle?.let { subtitle ->
                                div { className = ClassName("drives-move-option-sub"); +subtitle }
                            }
                        }
                        if (option == selected) {
                            span { +"✓" }
                        }
                    }
                }
            }
            div {
                className = ClassName("drives-dialog-actions")
                DotButton {
                    text = "Cancel"
                    variant = DotButtonVariant.Secondary
                    onClick = props.onCancel
                }
                DotButton {
                    text = when (selected.outcome) { "pledged" -> "Move & log pledge"; "received" -> "Enter gift details"; else -> "Move drive" }
                    enabled = selected.outcome != "pledged" || (props.askAmount?.let { it.isFinite() && it > 0 } == true)
                    onClick = { props.onConfirm(selected.outcome) }
                }
            }
        }
    }
}
